import { render, staticRenderFns } from "./ValoresPendentes.vue?vue&type=template&id=375f2a71&"
import script from "./ValoresPendentes.vue?vue&type=script&lang=js&"
export * from "./ValoresPendentes.vue?vue&type=script&lang=js&"
import style0 from "./ValoresPendentes.vue?vue&type=style&index=0&id=375f2a71&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports